var _path, _path2, _path3, _path4, _path5, _circle, _circle2, _circle3, _circle4, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCard2(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 68,
    height: 69,
    viewBox: "0 0 68 69",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.4654 19.7949C23.4308 19.5012 23.4137 19.1464 23.4274 18.7622C23.1807 15.5657 21.7927 14.7285 21.0655 14.7286C17.0125 13.6619 19.3768 11.0843 21.0655 9.92887C17.0125 8.43559 19.3768 6.28464 21.0655 5.39582C23.4121 -1.43041 25.4208 2.55156 26.1319 5.39582C30.3982 6.88906 27.9095 9.04003 26.1319 9.92887C30.1849 11.6354 27.8206 13.8397 26.1319 14.7286C24.0696 15.0723 23.4841 17.1697 23.4274 18.7622C23.4521 19.0822 23.4654 19.426 23.4654 19.7949Z",
    fill: "#82B253",
    stroke: "black",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M58.9397 43.7935H10.999C8.91863 43.7935 7.15103 45.3985 7.21304 47.4779C7.66061 62.4858 19.2649 67.2971 25.4506 67.7919H44.3827C58.3936 65.9723 62.2771 54.9695 62.6196 47.3607C62.7112 45.3267 60.9758 43.7935 58.9397 43.7935Z",
    stroke: "black",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M59.3716 44.3269H29.2218C28.2168 44.3269 27.3593 45.0772 27.2864 46.0796C26.2094 60.9036 37.1403 65.9086 43.4437 67.2019C43.6363 67.2414 43.8352 67.2482 44.0305 67.2256C58.1452 65.5926 61.9371 54.6548 62.1933 47.0793C62.246 45.5211 60.9307 44.3269 59.3716 44.3269Z",
    fill: "#D2D2D2"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M36.3427 42.3516C37.109 40.8675 39.305 38.2307 41.9592 39.5565",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M25.9819 43.7935H22.9159C20.4123 43.7935 18.3828 45.823 18.3828 48.3265V50.593C18.3828 51.8448 19.3976 52.8595 20.6493 52.8595H20.7827C21.9608 52.8595 22.9159 51.9045 22.9159 50.7263C22.9159 49.5482 23.8709 48.5932 25.0491 48.5932H25.3157C26.6411 48.5932 27.7155 49.6676 27.7155 50.993V54.1928C27.7155 55.3709 28.6706 56.326 29.8487 56.326C31.0269 56.326 31.9819 55.3709 31.9819 54.1928V49.7935C31.9819 46.4797 29.2956 43.7935 25.9819 43.7935Z",
    fill: "#82B253",
    stroke: "black",
    strokeWidth: 2
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 43.6658,
    cy: 6.13111,
    r: 4.13111,
    fill: "#F7F2E2",
    stroke: "black",
    strokeWidth: 2
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 59.1962,
    cy: 33.3942,
    r: 2.46644,
    fill: "#82B253",
    stroke: "black",
    strokeWidth: 2
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 43.3998,
    cy: 41.3998,
    r: 1.39985,
    fill: "#82B253",
    stroke: "black",
    strokeWidth: 2
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 31.9978,
    cy: 19.5281,
    r: 1.93315,
    fill: "#F7F2E2",
    stroke: "black",
    strokeWidth: 2
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2359 3.3664C14.4399 3.16241 14.6768 2.9989 14.9341 2.88106L14.9341 7.24822C14.6768 7.13037 14.4399 6.96687 14.2359 6.76288C13.7855 6.31247 13.5325 5.7016 13.5325 5.06464C13.5325 4.42767 13.7855 3.8168 14.2359 3.3664Z",
    fill: "#FF8700",
    stroke: "black",
    strokeWidth: 2
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M49.5924 37.5719C49.6637 36.5032 50.0595 35.4692 50.7206 34.6057L57.5236 42.0551C56.6039 42.6352 55.5384 42.9359 54.4675 42.9101C53.0715 42.8766 51.7819 42.2921 50.8734 41.2973C49.9649 40.3024 49.4995 38.9653 49.5924 37.5719Z",
    fill: "#FF4135",
    stroke: "black",
    strokeWidth: 2
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M66.0039 6.5882L55.009 17.5831C53.9634 18.6288 53.5244 20.1362 53.8452 21.5798C54.1856 23.1119 53.6695 24.7081 52.4965 25.7508L46.8657 30.756C45.5368 31.9372 43.7816 32.6748 42.0562 32.2461C37.6161 31.1429 36.5132 27.6817 36.5802 25.0014C36.609 23.8482 37.1972 22.8091 37.9604 21.9441L42.9597 16.2784C44.0674 15.0229 45.8326 14.5771 47.4036 15.1559C48.9009 15.7075 50.5825 15.3301 51.7004 14.1915L62.5376 3.15356C63.4878 2.18577 65.0449 2.17863 66.0039 3.13766C66.9568 4.0905 66.9568 5.63536 66.0039 6.5882Z",
    fill: "#FFDFBA",
    stroke: "black",
    strokeWidth: 2
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M41.3312 26.7282L41.2609 26.4236C40.8113 24.4755 41.4653 22.4376 42.9645 21.1147V21.1147C44.2824 19.9519 46.0804 19.4964 47.7929 19.8916L48.5307 20.0619",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M16.3486 21.4778L5.46755 10.5968C4.49942 9.62863 2.93893 9.59975 1.93563 10.5314C0.878401 11.5131 0.847609 13.1764 1.86778 14.1965L12.0822 24.4109C13.3949 25.7237 14.1324 27.5042 14.1324 29.3607V30.0019C14.1324 31.9909 14.9786 33.8861 16.4596 35.2139L20.3379 38.6909C21.3352 39.585 22.5712 40.2501 23.9095 40.195C28.7044 39.9978 30.5551 35.8889 31.0576 32.3716C31.305 30.6402 30.5121 28.9751 29.2754 27.7383L27.1153 25.5783C25.8026 24.2655 24.0221 23.528 22.1656 23.528H21.2983C19.4418 23.528 17.6613 22.7905 16.3486 21.4778Z",
    fill: "#F7F2E2",
    stroke: "black",
    strokeWidth: 2
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M27.198 39.26C25.7047 38.1934 23.0205 35.2602 21.865 33.927",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M29.8647 35.527L24.7983 30.4607",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M9.39697 43.5935C9.54086 43.1139 9.87109 42.4065 10.3793 41.9239C11.1321 41.2089 12.2998 40.6698 12.9517 39.8618C13.7906 38.8221 15.0008 38.3715 16.3175 40.4571C16.6946 41.0544 17.3107 41.4617 17.971 41.7126C18.7547 42.0104 19.427 42.5886 18.9964 43.5935",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCard2);
export default __webpack_public_path__ + "static/media/card2.0521447090db91171b3e3f62482d5fa9.svg";
export { ForwardRef as ReactComponent };